// 'use strict';

// var $ = require('jquery');
// var lodashSortBy = require('lodash/collection/sortBy');

// var StateDetection = require('state-detection-2.0.0');
// var triggerCustomEvent = require('trigger-custom-event');

// var pinboardLoadMore = require('./pinboard-load-more');
// var appDom = require('../app-dom');
// var utils = require('../utils/main');

// var pinboardLookup = {};

// var onPinboardStateChanged = function(e, data) {

// 	var blockId = utils.dom.getBlockId(utils.dom.closestBlock(data.$target));

// 	sortItems(blockId, 'change');

// };

// var onPinboardItemsLoaded = function (e, payload) {
// 	var data = payload && payload.data ? payload.data : payload;
// 	if (!data || !data.$pinboard) return;
  
// 	var $pinboard = data.$pinboard;
// 	var blockId = utils.dom.getBlockId(utils.dom.closestBlock($pinboard));
// 	var $incoming = $(data.markup).filter(function () { return this.nodeType === 1; });
// 	var $newLoadMoreItem = $incoming.find('.js-load-more-pinboard-items').closest('[data-pinboard-item], .pinboard-item').first();

// 	$pinboard.find('.js-load-more-pinboard-items').closest('.grid__cell').remove();
  
// 	if ($newLoadMoreItem.length) {
// 		$incoming = $incoming.not($newLoadMoreItem);
// 	}

// 	$pinboard.append($incoming);
  
// 	if ($newLoadMoreItem.length) {
// 	  $pinboard.append($newLoadMoreItem);
// 	}
  
// 	setVideoOrientations($pinboard, blockId);
  
// 	requestAnimationFrame(function () {
// 	  sortItems(blockId, 'change');
// 	});
// };

// var getColWidth = function($pinboard, numCols, gutterInt) {
// 	var boardW = $pinboard.width() || 0;
// 	var gutter = parseFloat(gutterInt) || 0;
// 	var guttersW = Math.max(0, (numCols - 1) * gutter);
// 	return numCols ? Math.max(0, (boardW - guttersW) / numCols) : boardW;
// }
  
// var getPaddingBottomPercent = function($aspect) {
// 	if (!$aspect || !$aspect.length) return 0;

// 	var style = $aspect.attr('style') || '';
// 	var m = style.match(/padding-bottom\s*:\s*([0-9.]+)%/i);
// 	if (m && m[1]) return parseFloat(m[1]) || 0;

// 	var pb = $aspect[0] && window.getComputedStyle ? window.getComputedStyle($aspect[0]).paddingBottom : '';
// 	var m2 = (pb || '').match(/([0-9.]+)%/);
// 	return (m2 && m2[1]) ? (parseFloat(m2[1]) || 0) : 0;
// }
  
// var estimateTileHeight = function($item, $pinboard, numCols, gutterInt) {
// 	var colW = getColWidth($pinboard, numCols, gutterInt);
// 	if (!colW) return 0;

// 	var $aspect = $item.find('.aspect-ratio').first();
// 	var pct = getPaddingBottomPercent($aspect);

// 	if (pct) return colW * (pct / 100);

// 	return estimateVideoHeightFromClass($item, $pinboard, numCols, gutterInt) || 0;
// }

// var sortItems = function (blockId, type) {
// 	var pinboard = pinboardLookup[blockId];
// 	if (!pinboard) return;
  
// 	var $pinboard = pinboard.$pinboard;
  
// 	var $detachedLoadMoreCell = $pinboard.find('.js-load-more-pinboard-items').closest('.grid__cell').first();
// 	$detachedLoadMoreCell = $detachedLoadMoreCell.length ? $detachedLoadMoreCell.detach() : null;
  
// 	var $pinboardClone = $pinboard.clone();
  
// 	var $pinboardItems = utils.dom.findPinboardItem($pinboardClone).filter(function () {
// 	  return $(this).find('.js-load-more-pinboard-items').length === 0;
// 	});
  
// 	var numCols = parseInt(pinboard.state.getState(), 10) || 1;
  
// 	$pinboard.removeClass('pinboard-layout--is-sorted');
  
// 	pinboard.cols = [];
// 	for (var c = 0; c < numCols; c++) pinboard.cols[c] = { col: c, height: 0 };
  
// 	var $sortedCols;
// 	for (var curCol = 0; curCol < numCols; curCol++) {
// 		var $sortedCol = $(
// 			'<div class="grid__cell" data-pinboard-col="' + curCol + '">' +
// 			'<div class="grid grid--col-1 grid--gutter-' + utils.dom.getGridGutter($pinboard) + '"></div>' +
// 			'</div>'
// 		);
// 		$sortedCols = (curCol === 0) ? $sortedCol : $sortedCols.add($sortedCol);
// 	}
  
// 	if (pinboard.isTrueMeasure) {
// 		pinboard.trueMeasureHeights = {};
// 		utils.dom.findPinboardItem($pinboard).each(function () {
// 			pinboard.trueMeasureHeights['' + utils.dom.getPinboardItemIndex(this)] = $(this).height() || 0;
// 		});
// 	}
  
// 	if (type === 'change') {
// 		$pinboardItems = $pinboardItems.sort(function (a, b) {
// 			return utils.dom.getPinboardItemIndex(a) - utils.dom.getPinboardItemIndex(b);
// 		});
// 	}
  
// 	$pinboardItems.each(function (i) {
// 		var $item = $pinboardItems.eq(i);
// 		var itemIndex = utils.dom.getPinboardItemIndex($item[0]);
	
// 		var sorted = lodashSortBy(pinboard.cols, 'height');
// 		var targetCol = (i < numCols) ? i : ((sorted[0] && sorted[0].col) || 0);
	
// 		$sortedCols.eq(targetCol).children().append($item);
	
// 		if (pinboard.isTrueMeasure) {
// 			var trueH = pinboard.trueMeasureHeights['' + itemIndex] || 0;
// 			pinboard.cols[targetCol].height += trueH + (parseFloat(pinboard.gutterInt) || 0);
// 			return;
// 		}

// 		var $aspectRatio = utils.dom.findAspectRatio($item);
// 		var $aspectRatioImg = utils.dom.findAspectRatioImg($aspectRatio);
	
// 		if ($aspectRatioImg && $aspectRatioImg.length) {
// 			if (
// 				!$aspectRatioImg.attr('data-lazy-image') &&
// 				!$aspectRatioImg.hasClass('lazy-image--loaded')
// 			) {
// 				$aspectRatioImg.removeClass('scroll-watch-in-view scroll-watch-ignore').attr('data-lazy-image', $aspectRatioImg.attr('data-pinboard-img-src'));
// 			}
// 		}

// 		var itemH = estimateTileHeight($item, $pinboard, numCols, pinboard.gutterInt);

// 		if (!itemH) {
// 			itemH = $item.outerHeight(true) || 0;
// 		}

// 		pinboard.cols[targetCol].height += (parseFloat(itemH) || 0) + (parseFloat(pinboard.gutterInt) || 0);
// 	});
  
// 	utils.dom.findChildCell($pinboard).remove();

// 	$pinboard.append($sortedCols).addClass('pinboard-layout--is-sorted');
  
// 	if ($detachedLoadMoreCell && $detachedLoadMoreCell.length) {
// 		var shortest = lodashSortBy(pinboard.cols, 'height')[0];
// 		var shortestCol = (shortest && typeof shortest.col === 'number') ? shortest.col : 0;
	
// 		$sortedCols.eq(shortestCol).children().append($detachedLoadMoreCell);
// 	}
  
// 	triggerCustomEvent('pinboard_sorted');
// };

// var estimateVideoHeightFromClass = function($item, $pinboard, numCols, gutterInt) {
// 	var boardW = $pinboard.width() || 0;
// 	var gutter = parseFloat(gutterInt) || 0;
// 	var guttersW = Math.max(0, (numCols - 1) * gutter);
// 	var colW = numCols ? Math.max(0, (boardW - guttersW) / numCols) : boardW;
  
// 	if (!colW) return 0;
  
// 	var ratio = 9 / 16;
  
// 	if ($item.hasClass('aspect-ratio--video-vertical') || $item.find('.aspect-ratio--video-vertical').length) {
// 	  	ratio = 16 / 9;
// 	} else if ($item.hasClass('aspect-ratio--square') || $item.find('.aspect-ratio--square').length) {
// 	  	ratio = 1;
// 	}
  
// 	return colW * ratio;
// };

// var setVideoOrientations = function ($pinboards) {
// 	function setWrapClass($videoWrap, w, h) {
// 		if (!$videoWrap || !$videoWrap.length || !w || !h) return;
	
// 		$videoWrap.removeClass('aspect-ratio--video-landscape aspect-ratio--video-vertical aspect-ratio--square');
	
// 		if (w > h) $videoWrap.addClass('aspect-ratio--video-landscape');
// 		else if (w < h) $videoWrap.addClass('aspect-ratio--video-vertical');
// 		else $videoWrap.addClass('aspect-ratio--square');
// 	}
  
// 	$pinboards.each(function () {
// 	  	var $pinboard = $(this);
  
// 		$pinboard.find('[data-pinboard-has-video="true"]').each(function () {
// 			var $item = $(this);
// 			var video = $item.find('video').get(0);
// 			var iframe = $item.find('iframe').get(0);
// 			var $videoWrap = $item.find('.aspect-ratio').first();
	
// 			if (video) {
// 			var onMeta = function () {
// 				setWrapClass($videoWrap, this.videoWidth, this.videoHeight);
// 			};
	
// 			if (video.readyState >= 1 && video.videoWidth && video.videoHeight) onMeta.call(video);
// 			else $(video).one('loadedmetadata', onMeta);
	
// 			// In some browsers metadata can be flaky; loadeddata is a good backup
// 			$(video).one('loadeddata', function () {
// 				if (video.videoWidth && video.videoHeight) setWrapClass($videoWrap, video.videoWidth, video.videoHeight);
// 			});
// 			} else if (iframe) {
// 			// Iframe dimensions are often only meaningful after load
// 			$(iframe).one('load', function () {
// 				var wAttr = iframe.getAttribute('width');
// 				var hAttr = iframe.getAttribute('height');
// 				var w = wAttr ? parseInt(wAttr, 10) : $(iframe).width();
// 				var h = hAttr ? parseInt(hAttr, 10) : $(iframe).height();
// 				setWrapClass($videoWrap, w, h);
// 			});
	
// 			// fallback: set a default if it never loads
// 			setWrapClass($videoWrap, 16, 9);
// 			}
// 		});
// 	});
// };
  
// var init = function() {

// 	var $content = $(appDom.content);
// 	var $pinboards = utils.dom.findPinboardLayout($content);

// 	if (!$pinboards || !$pinboards.length) {
// 		$pinboards = $content.find('.pinboard-layout');
// 	}

// 	if ($pinboards.length) {

// 		pinboardLoadMore.init();

// 		$pinboards.each(function(i) {

// 			var $pinboard = $pinboards.eq(i);
// 			var blockId = utils.dom.getBlockId(utils.dom.closestBlock($pinboard));

// 			setVideoOrientations($pinboard, blockId);

// 			$pinboard.on({
// 				'pinboard_state_changed': onPinboardStateChanged,
// 				'pinboard_items_loaded': onPinboardItemsLoaded
// 			});

// 			pinboardLookup[blockId] = {
// 				blockId: blockId,
// 				$pinboard: $pinboard,
// 				state: new StateDetection({
// 					target: '#block_' + blockId + ' .pinboard-layout',
// 					eventName: 'pinboard_state_changed'
// 				}),
// 				gutterInt: utils.dom.getGridGutterInt($pinboard),
// 				cols: [],
// 				trueMeasureHeights: {},
// 				// Note: logic for true measurement does not support load more functionality, if load more is needed, true measurement logic will need enhanced
// 				isTrueMeasure: $pinboard.hasClass('pinboard-layout--true-measure'),
// 				lastShortestPick: -1
// 			};

// 			sortItems(blockId, 'initial');

// 		});

// 	}

// };

// module.exports = {
// 	init: init
// };


'use strict';

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var lodashSortBy = require('lodash/collection/sortBy');

var StateDetection = require('state-detection-2.0.0');
var triggerCustomEvent = require('trigger-custom-event');

var pinboardLoadMore = require('./pinboard-load-more');
var appDom = require('../app-dom');
var utils = require('../utils/main');

var pinboardLookup = {};

var onPinboardStateChanged = function(e, data) {

	var blockId = utils.dom.getBlockId(utils.dom.closestBlock(data.$target));

	sortItems(blockId, 'change');

};

var onPinboardItemsLoaded = function(e, data) {

	var blockId = utils.dom.getBlockId(utils.dom.closestBlock(data.$pinboard));
	// Filter out any text nodes created from whitespace in the response markup
	var $pinboardItems = $(data.markup).not('text');

	sortItems(blockId, 'add', $pinboardItems);

};

var sortItems = function(blockId, type, $pinboardItems) {

	var pinboard = pinboardLookup[blockId];
	var $pinboard = pinboard.$pinboard;
	// Make a clone so all of our sorting is done in memory, not the actual dom
	var $pinboardClone = $pinboard.clone();
	var numCols = parseInt(pinboard.state.getState(), 10);
	var $sortedCols;
	var $sortedCol;
	var curCol;
	var $loadMoreItem;
	var loadMoreCol;

	$pinboard.removeClass('pinboard-layout--is-sorted');

	if (type === 'initial') {

		// This is our initial sort, simply grab the pinboard items from the clone, they will already be in order
		$pinboardItems = utils.dom.findPinboardItem($pinboardClone);

	} else if (type === 'change') {

		// The number of columns has changed, get the items from the clone, but before we visually sort them, we must sort them by source order since the dom can no longer be relied upon
		$pinboardItems = utils.dom.findPinboardItem($pinboardClone);
		pinboard.cols = [];

		$pinboardItems.sort(function(a, b) {

			var aIndex = utils.dom.getPinboardItemIndex(a);
			var bIndex = utils.dom.getPinboardItemIndex(b);

			if (aIndex > bIndex) {

				return 1;

			}

			if (aIndex < bIndex) {

				return -1;

			}

			return 0;

		});

	}

	if (type === 'add') {

		// We are adding to the columns we already have, so grab the columns from the clone
		$sortedCols = utils.dom.findPinboardCol($pinboardClone);

		// Find the existing load more item
		$loadMoreItem = utils.dom.findLastItem($sortedCols);

		// Determine which column the load more item resides in
		loadMoreCol = utils.dom.getPinboardCol(utils.dom.closestPinboardCol($loadMoreItem));

		// Remove the height of the load more item from our running counter
		pinboard.cols[loadMoreCol].height = pinboard.cols[loadMoreCol].height - utils.dom.getAspectRatioPadding(utils.dom.findAspectRatio($loadMoreItem));

		// Remove the load more item from the dom
		$loadMoreItem.remove();

	} else {

		// Create cell element for each column we need, and inside each column will be a nested grid
		for (curCol = 0; curCol < numCols; curCol++) {

			$sortedCol = $('<div class="grid__cell" data-pinboard-col="' + curCol + '"><div class="grid grid--col-1 grid--gutter-' + utils.dom.getGridGutter($pinboard) + '"></div></div>');

			if (!curCol) {

				$sortedCols = $sortedCol;

			} else {

				$sortedCols = $sortedCols.add($sortedCol);

			}

		}

	}

	// If we need a true size measurement for each item, loop over the items in the actual dom and store their heights
	if (pinboard.isTrueMeasure) {

		utils.dom.findPinboardItem($pinboard).each(function() {

			pinboard.trueMeasureHeights['' + utils.dom.getPinboardItemIndex(this)] = $(this).height();

		});

	}

	$pinboardItems.each(function(i) {

		var $pinboardItem = $pinboardItems.eq(i);
		var itemIndex = utils.dom.getPinboardItemIndex($pinboardItem[0]);
		var $aspectRatio;
		var $aspectRatioImg;
		var targetCol;

		if (itemIndex < numCols) {

			targetCol = itemIndex;

			pinboard.cols[targetCol] = {
				col: targetCol,
				height: 0
			};

		} else {

			// Sort the columns to find the column with the smallest height, the current item should be moved to this column
			targetCol = lodashSortBy(pinboard.cols, 'height')[0].col;

		}

		// Move the item into the smallest column
		$sortedCols.eq(targetCol)
			.children()
			.append($pinboardItem);

		if (pinboard.isTrueMeasure) {

			pinboard.cols[targetCol].height += pinboard.trueMeasureHeights['' + itemIndex] + pinboard.gutterInt;

		} else {

			$aspectRatio = utils.dom.findAspectRatio($pinboardItem);
			$aspectRatioImg = utils.dom.findAspectRatioImg($aspectRatio);

			if (!$aspectRatioImg.attr('data-lazy-image') && !$aspectRatioImg.hasClass('lazy-image--loaded')) {

				// This image has been processed by the lazy load module, but the image hasn't downloaded yet. We need to "reset" it, so when everything gets resorted and lazy image refreshes itself, it will re-process the image.
				$aspectRatioImg
					.removeClass('scroll-watch-in-view scroll-watch-ignore')
					// TODO: make the image size dynamic based on current state
					.attr('data-lazy-image', $aspectRatioImg.attr('data-pinboard-img-src'));

			}

			// We will not factor text underneath images into the slotting math, we would have to wait for custom fonts to finish downloading to get a truly accurate measurement
			pinboard.cols[targetCol].height += utils.dom.getAspectRatioPadding($aspectRatio) + pinboard.gutterInt;

		}

	});

	// Remove old columns from the dom
	utils.dom.findChildCell($pinboard).remove();

	// Add new sorted columns to the dom and make visible if necessary
	$pinboard
		.append($sortedCols)
		.addClass('pinboard-layout--is-sorted');

	triggerCustomEvent('pinboard_sorted');

};

var init = function() {

	var $pinboards = utils.dom.findPinboardLayout(appDom.content);

	if ($pinboards.length) {

		pinboardLoadMore.init();

		$pinboards.each(function(i) {

			var $pinboard = $pinboards.eq(i);
			var blockId = utils.dom.getBlockId(utils.dom.closestBlock($pinboard));

			$pinboard.on({
				'pinboard_state_changed': onPinboardStateChanged,
				'pinboard_items_loaded': onPinboardItemsLoaded
			});

			pinboardLookup[blockId] = {
				blockId: blockId,
				$pinboard: $pinboard,
				state: new StateDetection({
					target: '#block_' + blockId + ' .pinboard-layout',
					eventName: 'pinboard_state_changed'
				}),
				gutterInt: utils.dom.getGridGutterInt($pinboard),
				cols: [],
				trueMeasureHeights: {},
				// Note: logic for true measurement does not support load more functionality, if load more is needed, true measurement logic will need enhanced
				isTrueMeasure: $pinboard.hasClass('pinboard-layout--true-measure')
			};

			sortItems(blockId, 'initial');

		});

	}

};

module.exports = {
	init: init
};